export const data = [
  {
    id: '1',
    img: require('../../images/CLEANCODE.png').default,
    title: 'Cleancode',
    desc: 'Saas product with React, PHP, Laravel + MySQL. Team management + QR codes so the public can see cleaning history. Launched: 2/28/2022',
    accentClass: 'card-accent-1',
    link1: 'https://www.cleancode.us/',
    link2: 'https://www.cleancode.us/',
    professional: true,
  },
  {
    id: '2',
    img: require('../../images/proj1.png').default,
    title: 'Personal Website',
    desc: 'A personal website using React. Fully dynamic using custom Hooks, useState/Effect, and Smooth-scrooll + React-router.',
    link1: 'https://github.com/cameronmcc/personal-website-v2',
    link2: 'https://cameronsportfolio.netlify.app',
    accentClass: 'card-accent-2',
    professional: false,
  },
  {
    id: '3',
    img: require('../../images/proj4.png').default,
    title: 'Crypto Tracker',
    desc: "An app that displays cryptocurrency values in a table with historical price data using coingecko's api.",
    accentClass: 'card-accent-3',
    link1: 'https://github.com/cameronmcc/cryptoTracker',
    link2: 'https://cameronscrypto.netlify.app/',
    professional: false,
  },
  // {
  //   id: '3',
  //   img: require('../../images/weather.png').default,
  //   title: 'Weather App',
  //   desc: 'This App uses data from the openweathermap api and uses Vue.js. Type in a city to get current weather data!',
  //   accentClass: 'card-accent-3',
  //   link1: 'https://github.com/cameronmcc/weather-app',
  //   link2: 'https://camerons-weather-app.netlify.app/',
  // },
];
